import { render, staticRenderFns } from "./SideBarRight.vue?vue&type=template&id=85d0e286"
import script from "./SideBarRight.vue?vue&type=script&lang=js"
export * from "./SideBarRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85d0e286')) {
      api.createRecord('85d0e286', component.options)
    } else {
      api.reload('85d0e286', component.options)
    }
    module.hot.accept("./SideBarRight.vue?vue&type=template&id=85d0e286", function () {
      api.rerender('85d0e286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/SideBarRight.vue"
export default component.exports